import { motion } from "framer-motion";
import { prices } from "../data";

export default function Prices() {
  return (
    <section className="py-4 bg-light">
      <div className="container py-4">
        <h2 className="text-center display-5 fw-bold mb-5 blackT">Цены за заказ</h2>
        <div className="row g-4">
          {prices && prices.length > 0 ? (
            prices.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                viewport={{ once: true }}
                className="col-md-6 col-lg-4"
              >
                <div className="card h-100 shadow-sm border-0 rounded-4 p-3">
                  <div className="card-body pCard">
                    <h3 className="h5 fw-semibold mb-2">{item.name}</h3>
                    <p className="display-6 text-danger fw-bold">от {item.price}</p>
                  </div>
                </div>
              </motion.div>
            ))
          ) : (
            <p className="text-center">Цены временно недоступны</p>
          )}
        </div>
      </div>
    </section>
  );
}